(window as any).global = window;
(globalThis as any).global = window;
